import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {GalleriesService} from '../service/galleries.service';

@Injectable()
export class GalleryResolverService implements Resolve<any> {
  constructor(private galleriesService: GalleriesService) {
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<any> {

    return this.galleriesService.getGallerys();

  }
}
